<template>
    <div class="Report__field__content">
        <div class="Report__field__content__heading">
            <v-btn
                color="secondary"
                x-small
                @click="toggleCode"
            >
                <v-icon
                    left
                    x-small
                >
                    {{ buttonIcon }}
                </v-icon>{{ field.name }}
            </v-btn>
            <v-spacer />
            <CopyFieldValue :value="format(submission.text)" />
        </div>
        <div
            v-if="submission.text"
            class="Report__field__submission Report__field__submission--code"
            :class="{jsShowCode:showCode}"
        >
            <pre class="language-markup"><code>{{ format(submission.text) }}</code></pre>
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';
import CopyFieldValue from '@/reports/Fields/Common/CopyFieldValue';
export default {
    components: { CopyFieldValue },
    mixins: [
        ReportFieldBoilerplate,
    ],

    data() {
        return {
            showCode: false,
            buttonIcon: 'fas fa-eye'
        };
    },

    methods: {
        toggleCode() {
            this.showCode = !this.showCode;

            if (this.showCode) {
                this.buttonIcon = 'fas fa-times';
            } else {
                this.buttonIcon = 'fas fa-eye';
            }
        }
    }
};
</script>

<style lang="scss">
.Report__field__submission--code {
    height: 0;
    overflow: hidden;

    pre, code {
        white-space: pre-wrap !important;       /* Since CSS 2.1 */
        white-space: -moz-pre-wrap !important;  /* Mozilla, since 1999 */
        white-space: -o-pre-wrap !important;    /* Opera 7 */
        word-wrap: break-word !important;       /* Internet Explorer 5.5+ */
    }

    &.jsShowCode {
        height: auto;
        overflow: auto;
    }
}
</style>
